/**
 * Default DOM element ID for server-embedded data.
 * Both the server serializer and client reader use this as the default.
 */
export const SERVER_DATA_ELEMENT_ID = 'wf-server-data';
